"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReserveYourTime() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="189995" id="begin-your-transformation" className="dark bg-background text-foreground relative flex min-h-[70vh] items-center justify-center overflow-hidden py-24 sm:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 z-0 overflow-hidden">
        <div className="absolute -top-[30%] -left-[10%] h-[70%] w-[60%] rounded-full bg-primary/10 opacity-50 blur-[140px] mix-blend-screen transition-transform duration-1000 ease-in-out" style={{
        transform: isVisible ? 'translate(5%, 5%) scale(1.05)' : 'translate(0, 0) scale(1)'
      }} />
        <div className="absolute top-[50%] -right-[20%] h-[80%] w-[70%] rounded-full bg-primary/5 opacity-60 blur-[160px] mix-blend-screen transition-transform duration-1000 ease-in-out delay-300" style={{
        transform: isVisible ? 'translate(-5%, -5%) scale(1.1)' : 'translate(0, 0) scale(1)'
      }} />
      </div>

      {}
      <div ref={ref} className={`relative z-10 w-full max-w-5xl px-4 sm:px-6 lg:px-8 transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
        {}
        <div className="relative overflow-hidden rounded-sm bg-gradient-to-br from-primary to-primary/80 p-10 shadow-[0_20px_60px_-15px_rgba(184,134,11,0.3)] sm:p-16 md:p-24 text-center before:absolute before:inset-0 before:bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0IiBoZWlnaHQ9IjQiPgo8cmVjdCB3aWR0aD0iNCIgaGVpZ2h0PSI0IiBmaWxsPSIjZmZmIiBmaWxsLW9wYWNpdHk9IjAuMDUiLz4KPC9zdmc+')] before:opacity-30">
          
          {}
          <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none" />

          <div className="relative z-10 flex flex-col items-center justify-center gap-10">
            <h2 className="font-default text-4xl font-bold leading-tight tracking-tight text-primary-foreground sm:text-5xl md:text-6xl lg:text-7xl drop-shadow-sm">
              Ready to transform your space?
            </h2>

            <p className="text-lg max-w-2xl font-medium leading-relaxed !text-[hsl(0,0%,0%)] md:text-xl">If you are ready to make the transformation call us at (845)-659-6974 or email us at Landscapingtwins@gmail.com or feel free to fill out our consultation form in the Contact Us page.</p>
          </div>
        </div>
      </div>
    </section>;
}